/* eslint-disable no-use-before-define */
import React from 'react'
import { arrayToggle } from '../../../twd/twd'
import useScatterGraph from '../use-scatter-graph';
import CircleLabel from './circle-label'

export default () => {
    const {
        colors,
        RATINGS, ratings,setRatings
    } = useScatterGraph()


    return <React.Fragment>
    {
        RATINGS
        .map((a,i) => {
            return {
                label: a.label,
                value: a.value,
                color: colors[5+i],
                selected: ratings.indexOf(a.value)>=0
            }
        })
        .filter(a => a.selected)
        .map((a,i)=> (
            <a  href='#'
                key={i}
                data-name="municipals-scatter-graph-tag"
                className="tag tag-dismissible"
                style={{
                    margin: '1px',
                }}
                onClick={() => {
                    let n = arrayToggle(ratings, a.value)
                    setRatings([...n])
                }}
            ><CircleLabel color={a.color} label={a.label} />
            </a>
        ))
    }
    </React.Fragment>
}



// WEBPACK FOOTER //
// ./src/municipals/scatter-graph/criteria/tags.js